import { render, staticRenderFns } from "./SystemType.vue?vue&type=template&id=5e682fdc&scoped=true"
import script from "./SystemType.vue?vue&type=script&lang=js"
export * from "./SystemType.vue?vue&type=script&lang=js"
import style0 from "./SystemType.vue?vue&type=style&index=0&id=5e682fdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e682fdc",
  null
  
)

export default component.exports